import React from "react";
import { ReactComponent as FooterLogo } from "../../assets/icons/footer-logo.svg";
import Moment from "moment";
import packageJson from "../../../package.json";
import { Morph } from "../../constants/Text";
import './footer.scss';

const Footer = () => (
    <div className="foot-nav-bar">
        <span className="footer-logo"><FooterLogo /></span>
        <span className="copy-right-container">
            {Morph.WARNER_BROS_DISCOVERY}. {Morph.MORPH} v{packageJson.version}
            <br />
            Copyright &copy; {Moment().year()} {Morph.WARNER_BROS_DISCOVERY}. All rights reserved.
        </span>
    </div>
)

export default Footer;